// Rij die horizontaal scrolt (vegen op mobiel) met vorige- en volgende-knoppen op desktop.
// Gebruik: <scroll-row> met een [data-track] en knoppen met data-step="-1" en data-step="1".

class ScrollRow extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;
    this.buttons = [...this.querySelectorAll('[data-step]')];
    this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.buttons.forEach((button) => button.addEventListener('click', () => this.step(Number(button.dataset.step))));

    let frame;
    this.track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => this.update());
      },
      { passive: true }
    );
    this.resize = new ResizeObserver(() => this.update());
    this.resize.observe(this.track);
    this.update();
  }

  disconnectedCallback() {
    this.resize?.disconnect();
  }

  step(direction) {
    const item = this.track.querySelector(':scope > *');
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const width = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
    this.track.scrollBy({ left: direction * width, behavior: this.reduce ? 'auto' : 'smooth' });
  }

  update() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    this.toggleAttribute('data-static', max <= 2);
    this.buttons.forEach((button) => {
      const back = Number(button.dataset.step) < 0;
      button.disabled = back ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max - 2;
    });
  }
}

if (!customElements.get('scroll-row')) customElements.define('scroll-row', ScrollRow);
